// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ctm-ps-placeholder[data-v-504d45f1] {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 10px 14px;\n  border: 1px dashed #d1d5db;\n  border-radius: 6px;\n  background: #f9fafb;\n  color: #9ca3af;\n  font-size: 12px;\n  pointer-events: none;\n}\n.ctm-ps-placeholder__icon[data-v-504d45f1] {\n  font-size: 15px;\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n}\n", ""]);
// Exports
module.exports = exports;
